/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import brokingSchema from "./brokingSchema";
import mfdFaqSchema from "./mfdFaqSchema";
import licFaqSchema from "./licFaqSchema";
import articleSchema from "./articleSchema";
import becomeMfdFaqSchema from "./becomeMfdFaqSchema";
import nriFaqSchema from "./nriFaqSchema";

export {
  brokingSchema,
  mfdFaqSchema,
  licFaqSchema,
  articleSchema,
  becomeMfdFaqSchema,
  nriFaqSchema
};
